import axios from 'axios'
import { Hint, Topic } from '../types/data'
import { BASE_URL } from '../store/actions/thunk_actions'

export const getHints = async (topic: Topic) => {
    const hints: Hint[] = await axios.get(`${BASE_URL}hints?topic=${topic.id}`).then((response) => response.data.items)
    return hints
}
